import React, { useState, useContext } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminNavbar  from "./AdminNavbar";
import { AuthContext } from "../context/AuthContext";

const AdminLayout = () => {
  const { logout }  = useContext(AuthContext);
  const navigate    = useNavigate();

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen,       setIsMobileOpen]       = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/admin-login");
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">

      {/* Navbar */}
      <AdminNavbar onLogout={handleLogout} />

      <div className="flex flex-1 overflow-hidden">

        {/* Sidebar */}
        <AdminSidebar
          role="ADMIN"
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
        />

        {/* Mobile overlay */}
        {isMobileOpen && (
          <div
            className="fixed inset-0 bg-black/30 z-30 md:hidden"
            onClick={() => setIsMobileOpen(false)}
          />
        )}

        {/* Main content */}
        <main className="flex-1 min-w-0 overflow-auto p-4 md:p-6 transition-all duration-300">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
